import { SortDescriptor } from '@progress/kendo-data-query'
import { TicketKey, TicketSortKey } from 'api/Tickets/Types/TicketDto'

export const normalizeTicketsSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === TicketKey.NUMBER) {
        return { ...x, field: TicketSortKey.NUMBER }
      }
      if (x.field === TicketKey.TYPE) {
        return { ...x, field: TicketSortKey.TYPE }
      }
      if (x.field === TicketKey.CLIENT) {
        return { ...x, field: TicketSortKey.CLIENT }
      }
      if (x.field === TicketKey.COUNTRY) {
        return { ...x, field: TicketSortKey.COUNTRY }
      }
      if (x.field === TicketKey.TICKMILL_COMPANY) {
        return { ...x, field: TicketSortKey.TICKMILL_COMPANY }
      }
      if (x.field === TicketKey.STATUS) {
        return { ...x, field: TicketSortKey.STATUS }
      }
      if (x.field === TicketKey.ASSIGNEE) {
        return { ...x, field: TicketSortKey.ASSIGNEE }
      }
      if (x.field === TicketKey.DESCRIPTION) {
        return { ...x, field: TicketSortKey.DESCRIPTION }
      }
      if (x.field === TicketKey.DATE_CREATED) {
        return { ...x, field: TicketSortKey.DATE_CREATED }
      }
      if (x.field === TicketKey.DATE_UPDATED) {
        return { ...x, field: TicketSortKey.DATE_UPDATED }
      }
      return x
    })
    .filter((x) => !!x)
